import React, { useState } from "react";
import Slider from "react-slick";
import ReactPlayer from "react-player/youtube";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SynthesiaVideo from "../microSites/edit/tabs/SynthesiaVideo";

export default function ImageSlider({ data }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 1,
    autoplay: false,
    dots: false,
    arrows: true,
    adaptiveHeight: false,
    // Add this callback to track slide changes
    afterChange: (index) => {
      setCurrentSlide(index);
    },
  };

  if (data && data.length > 0 && data[0].id) {
    return (
      <div className="custom-slider-container">
        <Slider {...settings}>
          {data &&
            data?.map((item, i) => {
              if (
                item?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
                item.mediaLink.url
              ) {
                return (
                  <div key={i} className="slide">
                    <ReactPlayer
                      controls={true}
                      url={item.mediaLink.url}
                      width={"100%"}
                    />
                  </div>
                );
              } else if (
                item?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
                item.mediaLink.url
              ) {
                return (
                  <div key={i} className="slide">
                    <iframe
                      controls={true}
                      src={item.mediaLink.url}
                      width="100%"
                      style={{ backgroundColor: "black" }}
                    />
                  </div>
                );
              } else if (
                item?.mediaLink?.mediaType === "IMAGE" &&
                item.mediaLink.url
              ) {
                return (
                  <div key={i} className="slide">
                    <div className="img-slide" style={{ backgroundColor: 'white' }}>
                      <img
                        src={item?.mediaLink?.url}
                        alt={item?.title || ""}
                        className="c1 carousel-image"
                      />
                    </div>
                  </div>
                );
              }
              else if(
                item?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
                item.mediaLink.url) {
                  return (
                    <div>
                <SynthesiaVideo key={item.id} videoData={item} />
          
                    </div>
                              )
                }
            })}
        </Slider>
        
        <div className="slide-title">
          {data[currentSlide]?.title || "No title"}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
}